import filterByText from "Common/componentUtils/filterByText";
import constant from "lodash/constant";
import filter from "lodash/filter";
import some from "lodash/some";
import { FilteredGraphWrapper } from "yfiles";
export default (graphComponentRef, graphAdapterRef, filterText) => {
    if (!graphComponentRef.current || !graphAdapterRef.current)
        return;
    const nodes = graphAdapterRef.current.originalGraph.nodes.toArray();
    const filteredNodes = new Set(!filterText
        ? nodes
        : filter(nodes, node => {
            if (!node.tag)
                return true;
            const nodeTag = node.tag;
            return filterByText(filterText, nodeTag.Name) || filterByText(filterText, nodeTag.Id);
        }));
    const wrapper = new FilteredGraphWrapper(graphAdapterRef.current.originalGraph, !filterText
        ? constant(true)
        : node => {
            if (filteredNodes.has(node))
                return true;
            if (!graphAdapterRef.current)
                return false;
            const predecessors = graphAdapterRef.current.originalGraph.predecessors(node).toArray();
            if (some(predecessors, p => filteredNodes.has(p)))
                return true;
            const successors = graphAdapterRef.current.originalGraph.successors(node).toArray();
            return some(successors, s => filteredNodes.has(s));
        }, constant(true));
    graphComponentRef.current.graph = wrapper;
};
